// extracted by mini-css-extract-plugin
module.exports = {"nav__search-title":"NavSearchPanel_nav__search-title__RngA5","nav__search-input-wrap":"NavSearchPanel_nav__search-input-wrap__PE3WN"};